<template>
  <div>
    <div class="d-flex justify-content-center mb-1">
      <b-spinner variant="success" span="Spinning" block v-if="loadingSpinner"
        style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <section class="invoice-add-wrapper" v-if="!loadingSpinner">
      <b-row class="invoice-add">
        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="9" md="8">
          <validation-observer v-slot="{ invalid }" ref="purchaseorder">
            <b-form @submit.prevent>
              <b-card no-body class="invoice-preview-card">
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">

                  <div class="row align-items-center mb-2">
                <div class="">
                  <Logo />
                </div>
                <div class="col-9">
                  <div class="">
                    <CompanyName />
                  </div>
                  <div class="">
                    <Address />
                  </div>
                </div>
              </div>

                  <div class="d-flex justify-content-end flex-md-row flex-column invoice-spacing mt-0">
                    <!-- Header: Right Content -->
                    <div class="invoice-number-date mt-md-0 mt-2">
                      <div class="d-flex align-items-center justify-content-md-end mb-1">
                        <h4 class="invoice-title">
                          Purchase Invoice #{{ purchaseorderId.orderNumber }}
                        </h4>
                      </div>
                      <div class="d-flex align-items-center mb-1">
                        <span class="title"> Date: </span>
                        <flat-pickr v-model="issuedDate" :config="config" class="form-control invoice-edit-input" />
                      </div>
                      <validation-provider rules="required" v-slot="{ errors }" name="Due Date" vid="Due Date">
                        <div class="d-flex align-items-center">
                          <span class="title"> Due Date: </span>
                          <flat-pickr v-model="purchaseorderId.dueDate" :config="configDue" :class="[
                            { 'is-invalid': errors.length },
                            'form-control invoice-edit-input',
                          ]" />
                        </div>
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </div>
                  </div>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing" />
                <div class="d-flex justify-content-center align-items-center">
                  <b-spinner variant="success" span="Spinning" block v-if="loadInvoiceData"
                    style="width: 3rem; height: 3rem"></b-spinner>
                </div>
                <!-- Invoice Client & Payment Details -->
                <b-card-body class="invoice-padding pt-0">
                  <b-row class="invoice-spacing">
                    <!-- Col: Invoice To -->
                    <b-col cols="6" xl="6" class="mb-lg-1">
                      <h6 class="mb-2">Choose Supplier:*</h6>
                      <validation-provider rules="required" v-slot="{ errors }" name="Supplier" vid="supplierId">
                        <b-form-select v-model="purchaseorderId.supplierId" :options="optionsCustomer"
                          placeholder="select supplier" @change="supplierSelected(supplierId)" />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                      <!-- Selected Client -->
                      <!-- <div v-if="whenSelected !== null" class="mt-1">
                    <b-card-text class="mb-25">
                      {{ whenSelected.name }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      {{ whenSelected.email }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      {{ whenSelected.address }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      {{ whenSelected.phoneNumber }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ whenSelected.contactPerson }}
                    </b-card-text>
                  </div> -->
                    </b-col>
                    <b-col cols="6" xl="6" class="mb-lg-1">
                      <h6 class="mb-2">Choose Warehouse:</h6>
                      <validation-provider rules="required" v-slot="{ errors }" name="Warehouse" vid="warehouseId">
                        <b-form-select v-model="purchaseorderId.warehouseId" placeholder="select warehouse"
                          :options="optionsWarehouse" />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-card-body>
                <!-- Items Section -->
                <b-card-body v-if="!loadInvoiceData" class="invoice-padding">
                  <div ref="form" class="repeater-form">
                    <b-row v-for="(item, index) in invoiceData.items" :key="index" ref="row" class="pb-2">
                      <!-- Item Form -->
                      <b-col cols="12">
                        <!-- Form Input Fields OR content inside bordered area -->
                        <div class="d-flex border rounded">
                          <b-row class="flex-grow-1 p-2">
                            <!-- Single Item Form Fields -->
                            <b-col cols="12" lg="4">
                              <label class="static-label">Items</label>
                              <div v-if="optionsProduct.length === 0" class="d-flex justify-content-center">
                                <b-spinner variant="primary"></b-spinner>
                              </div>
                              <div v-else>
                                <validation-provider rules="required" v-slot="{ errors }" name="Item"
                                  :vid="`Item_${index}`">
                                  <v-select v-model="item.name" :options="optionsProduct" label="itemTitle"
                                    :disabled="item.disabledItem" :clearable="false" :class="[
                                      { 'is-invalid': errors.length },
                                      'mb-2 item-selector-title',
                                    ]" placeholder="Select Item" @input="(val) => updateItemForm(index, val)" />
                                  <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </div>
                            </b-col>
                          <b-col cols="12" lg="3">
                            <label class="static-label">Unit Price (Rs)</label>

                            <validation-provider
                              name="Unit Price"
                              :rules="{ message_unit_price:item.purchasePrice, required: true }"
                              v-slot="{ errors }"
                            >
                              <b-form-input
                                type="number"
                             
                                v-model="item.purchasePrice"
                                
                              />
                               <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-col>
                            <b-col cols="12" lg="2">
                              <label class="static-label">Qty*</label>
                              <b-form-input v-model="item.qty" type="number" class="mb-2" min="1"
                                invalid-feedback="Quantity must be 1 or more" @change="validateQuantity" required />
                              <div v-if="quantityError" class="invalid-feedback">
                                {{ quantityError }}
                              </div>
                            </b-col>
                            <b-col cols="12" lg="2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="flex-grow-1">
                                  <label class="static-label">Total Price</label>
                                  <p class="mb-1">Rs {{ item.computedPrice }}</p>
                                </div>
                              </div>
                              <div class="mb-1">
                                <b-button variant="danger" size="sm" @click="removeItem(index)">
                                  Remove
                                </b-button>
                              </div>
                            </b-col>
                            <b-col cols="12" lg="6">
                              <span class="d-inline d-lg-none">Description</span>
                              <b-form-textarea class="mb-2 mb-lg-0" v-model="item.description" />
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary"
                    @click="addNewItemInItemForm">
                    Add Item
                  </b-button>
                </b-card-body>

                <!-- Invoice Description: Total -->
                <b-card-body class="invoice-padding pb-0">
                  <b-row>
                    <!-- Col: Sales Person -->
                    <b-col cols="12" md="6" class="mt-md-0 mt-3 d-flex align-items-center" order="2" order-md="1">
                      <span for="invoice-data-sales-person" class="text-nowrap mr-50">Issuer:</span>
                      <validation-provider rules="required" v-slot="{ errors }" name="Sales Person" vid="Sales Person">
                        <b-form-select v-model="purchaseorderId.salesPersonId" :options="optionsSalesPerson" />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </b-col>

                    <!-- Col: Total -->
                    <b-col cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                      <div class="invoice-total-wrapper">
                        <hr class="my-50" />
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">Total:</p>
                          <p class="invoice-total-amount">
                            Rs {{ totalPrice }}
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing" />

                <!-- Note -->
                <b-card-body class="invoice-padding pt-0">
                  <span class="font-weight-bold">Note: </span>
                  <b-form-textarea v-model="purchaseorderId.note" />
                </b-card-body>
              </b-card>
            </b-form>
          </validation-observer>
        </b-col>

        <!-- Right Col: Card -->
        <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
          <!-- Action Buttons -->
          <b-card>
            <!-- Button: Save -->
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" block
              @click="addSalesOrder()" :disabled="loadingButton"
              :style="loadingButton ? { cursor: 'not-allowed' } : {}">
              <b-spinner small v-if="loading"></b-spinner>
              Save
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { ref, watch } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import { debounce } from "lodash";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormSelect,
  BSpinner,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "{_field_} field is required",
});


extend("message_unit_price", {
  validate(value) {
    return value > 0;
  },
  message: "Unit Price must be greater than 0",
});
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormSelect,
    BSpinner,
    BFormInput,
    BFormTextarea,
    flatPickr,
    Logo,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    Address,
    CompanyName,
  },
  directives: {
    ripple: Ripple,
  },
  data() {
    return {
      id: this.$route.query.PoID,
      whenSelected: {},
      supplierId: null,
      warehouseId: null,
      quantity: 1,
      quantityError: "",
      invoiceData: {
        items: [],
      },
      issuedDate: new Date(),
      dueDate: null,
      salesPersonId: "",
      optionsSalesPerson: [],
      note: "",
      loadingSpinner: false,
      loadInvoiceData: true,
      optionsProduct: [],
      optionsCustomer: [],
      optionsWarehouse: [],
      config: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        disable: [new Date()],
      },
      configDue: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        minDate: new Date(),
      },
      totalPrice: 0, // Initialize totalPrice
      disabledItem: true,
      loadingButton: false,
    };
  },
  computed: {
    ...mapGetters("productModule", {
      ProductList: "product",
      productID: "productID",
      loading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      RawMaterialList: "rawmaterials",
      rawmaterialsID: "rawmaterialsID",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("purchaseOrderModule", {
      purchaseorderId: "purchaseorderId",
      loading: "loading",
    }),
    ...mapGetters("purchaseInvoiceModule", {
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),
    ...mapGetters("supplierModule", {
      SupplierList: "suppliers",
      supplier: "supplierId",
      supplierLoading: "loading",
    }),
  },
  methods: {
    ...mapActions("productModule", [
      "getProductListAction",
      "getProductIDAction",
    ]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    ...mapActions("supplierModule", [
      "getSupplierListAction",
      "getSupplierByIDAction",
    ]),
    ...mapActions("purchaseOrderModule", ["getPurchaseOrdersByIDAction"]),
    ...mapActions("purchaseInvoiceModule", ["addPurchaseInvoicesAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("rawmaterialModule", [
      "getRawMaterialListAction",
      "getRawMaterialListByIdAction",
    ]),
    removeItem(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
      // Recalculate total price after removing the item
      this.recalculatePrices();
    },

    async initializeItemData() {
      this.loadInvoiceData = true;
      try {
        let totalPrice = 0;
        console.log("Full Purchase Order Items:", this.purchaseorderId.purchaseOrderItems);

        // Extract itemId and description from each object in purchaseOrderItems
        const items = this.purchaseorderId.purchaseOrderItems.map((item) => ({
          id: item.itemId,
          note: item.description || "",
          qty: item.quantity || 1,
          cost: item.cost,
        }));

        // Process each item
        for (const { id, note, qty, cost } of items) {
          const product = await this.getProductIDAction(id);
          if (product) {
            const { id, name } = product;

            const itemTotalPrice = parseFloat(cost) * parseFloat(qty);
            console.log("🚀 ~ initializeItemData ~ this.purchaseorderId.purchaseOrderItems.cost:", cost)
            this.invoiceData.items.push({
              id,
              name,
              purchasePrice: cost,
              qty,
              computedPrice: itemTotalPrice.toFixed(2),
              description: note, // Add the note to the description field
              tax: 0,
              profit: 0,
              discount: 0,
              disabledItem: true,
            });
            totalPrice += itemTotalPrice;
          }
        }

        this.totalPrice = totalPrice.toFixed(2);
      } catch (error) {
        console.error("Error initializing data:", error);
      } finally {
        this.loadInvoiceData = false;
      }
    },
    updateItemForm(index, val) {
      const selectedItem = this.optionsProduct.find(
        (option) => option.value === val.value
      );

      if (selectedItem) {
        // Update item fields based on the selected option
        const item = this.invoiceData.items[index];
        item.name = selectedItem.itemTitle;
        item.purchasePrice = selectedItem.purchasePrice;
        item.computedPrice = (selectedItem.purchasePrice * item.qty).toFixed(2);
        item.description = selectedItem.description;
        item.tax = selectedItem.tax;
        item.profit = selectedItem.profit;
        item.id = selectedItem.value;

        // Recalculate total price after updating
        this.recalculatePrices();
      }
    },

    // Ensure to define recalculatePrices to update the totalPrice
    recalculatePrices() {
      this.totalPrice = this.invoiceData.items
        .reduce((total, item) => {
          return total + parseFloat(item.computedPrice);
        }, 0)
        .toFixed(2);
    },
    supplierSelected(id) {
      this.whenSelected = this.optionsCustomer.find((item) => item.id === id);
    },
    addNewItemInItemForm() {
      // Add item to the list of items, ensuring to include item IDs
      this.invoiceData.items.push({
        id: "",
        name: "",
        purchasePrice: 0,
        qty: 1,
        computedPrice: "0.00",
        description: "",
        tax: 0,
        profit: 0,
        discount: 0,
      });
    },
    validateQuantity(index) {
      const item = this.invoiceData.items[index];
      if (item.qty < 1) {
        this.quantityError = "Quantity must be 1 or more";
      } else {
        this.quantityError = "";
      }
    },
    success() {
      this.$swal({
        title: "Success!",
        text: "You have successfully converted the Purchase Order into Purchase Invoice!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(this.$router.push({ name: "purchaseinvoices-list" }));
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    addSalesOrder: debounce(function () {
      this.$refs.purchaseorder.validate().then((isValid) => {
        if (!isValid) {
          // Find the first invalid field
          const firstErrorField = this.$el.querySelector(".text-danger");
          if (firstErrorField) {
            // Scroll to the first invalid field
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
            // Set focus on the first invalid field
            firstErrorField.focus();
          }
        } else {
          if (this.invoiceData.items.length === 0) {
            this.error("Cannot add order without lines");
            return false;
          } else {
            this.loadingButton = true;
            let payload = {
              purchaseOrderId: this.id,
              status: 0,
              supplierId: this.purchaseorderId.supplierId,
              issueDate: this.issuedDate,
              salesPersonId: this.purchaseorderId.salesPersonId,
              paymentMethod: "string",
              dueDate: this.purchaseorderId.dueDate,
              subTotal: this.subTotal,
              discount: 0,
              tax: 0,
              warehouseId: this.purchaseorderId.warehouseId,
              total: this.totalPrice,
              note: this.purchaseorderId.note,
              hasConvertedToPurchaseInvoice: true,
              purchaseInvoiceItems: this.invoiceData.items.map((item) => ({
                itemId: item.id,
                itemName: item.name,
                isActive: true,
                cost: item.purchasePrice,
                quantity: item.qty,
                price: item.computedPrice,
                discount: item.discount,
                description: item.description,
              })),
            };

            this.addPurchaseInvoicesAction(payload)
              .then(() => {
                this.loadingButton = false;
                this.success();
              })
              .catch((error) => {
                this.loadingButton = false;
                console.error("Error adding purchase order", error);
                this.error(error);
              });
          }
        }
      });
    }, 300),
  },
  mounted() {
    this.getSupplierListAction().then(() => {
      this.SupplierList.map((v, i) =>
        this.optionsCustomer.push({
          value: v.id,
          text: `${v.name}`,
        })
      );
    });
    this.getWarehouseListAction().then(() => {
      this.warehouses.map((v, i) =>
        this.optionsWarehouse.push({
          value: v.id,
          text: `${v.name}`,
        })
      );
    });
    this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    this.getProductListAction(true).then(() => {
      this.ProductList.map((v, i) => {
        if (v.type !== 4) {
          this.optionsProduct.push({
            qty: 1,
            value: v.id,
            itemTitle: `${v.name}`,
            cost: v.salePrice,
            tax: v.saleTaxPercentage,
            purchasePrice: v.purchasePrice,
            profit: v.markUpPercentage,
            description: v.description,
          });
        }
      });
    });
    this.getPurchaseOrdersByIDAction(this.id)
      .then(() => {
        this.initializeItemData();
        console.log("this.purchaseorderId", this.purchaseorderId);
        console.log(
          "this.purchaseorderId.dueDate",
          this.purchaseorderId.dueDate
        );
      })
      .catch((response) => {
        console.log(response);
      });
  },
  watch: {
    "invoiceData.items": {
      handler(items) {
        items.forEach((item) => {
          item.computedPrice = (item.purchasePrice * item.qty).toFixed(2);
        });
        this.recalculatePrices(); // Optionally recalculate the total price
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.invoice-total-wrapper {
  width: 100% !important;
  max-width: 30rem !important;
}

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
